import React from 'react'

export const BackIcon = ({ width = 20, style, color = '#000' }) => {
    return (
        <svg
            class="Icon CloseIcon HighlightSol HighlightSol--core"
            data-testid="CloseIcon"
            viewBox="0 0 32 32"
            aria-hidden="true"
            focusable="false"
            width={width}
            height={width}
            style={style}
            fill={color}
        >
            <path d="M3 15h18.379L13.94 7.561a1.5 1.5 0 1 1 2.121-2.121l10 10a1.5 1.5 0 0 1 0 2.121l-10 10A1.495 1.495 0 0 1 15 28a1.5 1.5 0 0 1-1.061-2.56l7.439-7.439H3a1.5 1.5 0 1 1 0-3V15ZM30.5 2.5A1.5 1.5 0 0 0 29 4v25a1.5 1.5 0 1 0 3 0V4a1.5 1.5 0 0 0-1.5-1.5Z"></path>
        </svg>
    )
}

